import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import languageManager from '../../../../services/languageManager';
import * as storeActions from '../../../personal_data/customer_groups/store/actions/groups'

import Loader from '../../../common/PageElements/Loader'

import { Row, Col, Modal, Table, Button, Space, Typography, Collapse, notification } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

const ModalSelectGroups = (props) => {
    console.log('ModalSelectGroups', props);
    const [componentLoader, setComponentLoader] = useState(true);
    const [tableLoader, setTableLoader] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [fullListIds, setFullListIds] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    let hasSelected = selectedRowKeys.length > 0;
    let singleSelected = selectedRowKeys.length === 1;

    const { Text, Title } = Typography;

    useEffect(() => {
        if (!props.showModal) return;
        setComponentLoader(true);
        Promise.all([
            getList(),
        ]).then(() => {
            setComponentLoader(false);
        });
    }, [props.showModal]);

    // useEffect(() => {
    // }, [componentLoader, tableLoader]);

    const onConfirm = (selectedKeys) => {
        console.log('onConfirm', selectedKeys);
        if (selectedKeys.length <= 0) {
            notification.open({
                message: languageManager.getMessage(props.commonState, 'notification.warning.title'),
                description: languageManager.getMessage(props.commonState, 'notification.error.noSelections'),
                icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            });
            return;
        } else if (selectedKeys.length > 5) {
            notification.open({
                message: languageManager.getMessage(props.commonState, 'notification.warning.title'),
                description: languageManager.getMessage(props.commonState, 'notification.error.tooManySelections'),
                icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            });
            return;
        } else {
            props.onConfirm(selectedKeys);
            closeModal();
        }
    }
    const closeModal = () => {
        setSelectedRowKeys([]);
        props.onClose();
    }

    const getList = () => {
        setTableLoader(true);
        return storeActions.getList()
            .then(response => {
                console.log('getList', response);
                setTableLoader(false);
                try {
                    setItemList(response.data);
                    setFullListIds(response.full_list_ids);
                } catch (e) {
                    notification.open({
                        message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                        description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                        icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                    })
                }
            }).catch((e) => {
                notification.open({
                    message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                    description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
                    icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                })
                if (this.props.commonState.debug) console.log(e);
            });
    }

    const rowSelectionHandler = (selectedRowKeys, selection) => {
        console.log('rowSelectionHandler changed: ', selectedRowKeys);
        setSelectedRowKeys(selectedRowKeys);
    }
    const tableLayout = {
        bordered: true,
        size: "small",
        loading: tableLoader,
        pagination: false,
        className: 'table-smaller'
    }
    const table_columns = [
        {
            title: 'Gruppo', key: 'group',
            fixed: 'left',
            render: (record) => (
                record.name
            ),
            sorter: (a, b) => a.name.localeCompare(b.name)
        },
    ];

    const modalContent = (
        <Space direction="vertical" size="small" className='w-100-i'>
            <Text>{props.title}</Text>
            <Row>
                <Col span={12}>
                    <Space>
                        <span>
                            {hasSelected ? !singleSelected ? `${selectedRowKeys.length} elementi selezionati` : `${selectedRowKeys.length} elemento selezionato` : ''}
                        </span>
                    </Space>
                </Col>
            </Row>
            <Table {...tableLayout}
                columns={table_columns}
                dataSource={itemList}
                rowKey={(record) => (record.id)}
                rowSelection={{
                    selectedRowKeys: selectedRowKeys,
                    onChange: rowSelectionHandler,
                }}
            />
        </Space>
    );

    return (
        <Modal
            title={props.title}
            centered
            open={props.showModal}
            // onOk={() => closeModal()}
            onCancel={() => closeModal()}
            className='w-50-i'
            footer={[
                <Button key="close" onClick={closeModal}>Chiudi</Button>,
                <Button type='primary' key="confirm" onClick={() => { onConfirm(selectedRowKeys) }}>Conferma</Button>,
            ]}
        >
            {componentLoader ? <Loader /> : modalContent}
        </Modal>
    )
}


function mapStateToProps(state) {
    return {
        commonState: state.commonState
    };
}

export default connect(mapStateToProps)(ModalSelectGroups);